var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700 266.667C700 193.333 640 133.333 566.667 133.333H233.333C160 133.333 100 193.333 100 266.667V393.333C80 410 66.6666 436.667 66.6666 466.667V556.667V566.667V633.333C66.6666 653.333 80 666.667 100 666.667C120 666.667 133.333 653.333 133.333 633.333V600H666.667V633.333C666.667 653.333 680 666.667 700 666.667C720 666.667 733.333 653.333 733.333 633.333V566.667V556.667V466.667C733.333 436.667 720 410 700 393.333V266.667ZM166.667 266.667C166.667 230 196.667 200 233.333 200H566.667C603.333 200 633.333 230 633.333 266.667V366.667H600V333.333C600 276.667 556.667 233.333 500 233.333H466.667C440 233.333 416.667 243.333 400 260C383.333 243.333 360 233.333 333.333 233.333H300C243.333 233.333 200 276.667 200 333.333V366.667H166.667V266.667ZM533.333 333.333V366.667H433.333V333.333C433.333 313.333 446.667 300 466.667 300H500C520 300 533.333 313.333 533.333 333.333ZM366.667 333.333V366.667H266.667V333.333C266.667 313.333 280 300 300 300H333.333C353.333 300 366.667 313.333 366.667 333.333ZM666.667 533.333H133.333V466.667C133.333 446.667 146.667 433.333 166.667 433.333H266.667H366.667H433.333H533.333H633.333C653.333 433.333 666.667 446.667 666.667 466.667V533.333Z",
    fill: "#004C70",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomPlaceholder);
export default __webpack_public_path__ + "static/media/room-placeholder.9d89ee444b660079b483dcf13906fa15.svg";
export { ForwardRef as ReactComponent };